/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import preloaderIcon from 'assets/images/preloader.svg';

/**
 * Style dependencies
 */
import './styles.scss';

const Preloader = (props) => {
	return (
		<div className='preloader' style={{ background: props.background }}>
			<img src={preloaderIcon} alt='loading ...' />
		</div>
	);
};

Preloader.defaultProps = {
	background: '#fff',
};
Preloader.propTypes = {};

export default Preloader;
